import { Component, signal, output, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'base-add-to-cart-input',
  imports: [CommonModule],
  templateUrl: './add-to-cart-input.component.html',
  styleUrls: ['./add-to-cart-input.component.scss']
})
export class AddToCartInputComponent {


  readonly control = input<AbstractControl | null>(null);
  readonly value = input<number>(0);

  // Update outputs to use Angular 20 output() function
  increase$ = output<number>();
  decrease$ = output<number>();
  quantityChanged$ = output<number>();

  constructor() {

  }

  changeQuantity(quantity: string) {
    if (isNaN(+quantity) || +quantity === 0) {
      return;
    }
    this.quantityChanged$.emit(+quantity);
  }

  onIncrease() {
    this.increase$.emit(this.value() + 1);
  }

  onDecrease() {
    this.decrease$.emit(this.value() - 1);
  }

}

